import * as C from '@/consts'
import * as config from './config'
import * as a from '@/libs/a'

export default {
  // タイムアウト時間(分)
  timoutMinutes (state) {
    return config.TIMEOUT
  },

  // タイムオーバーか
  timeLimit (state) {
    return state.timeLimit
  },

  // 許諾事項に同意したか
  agreed (state) {
    return state.agreed
  },

  // アカウント情報
  account (state) {
    return state.account
  },

  // 個人情報
  profile (state) {
    return state.profile
  },

  // 免許証情報
  license (state) {
    return state.license
  },

  // 同意事項
  optins (state) {
    return state.optins
  },

  // 外国人の取り扱い
  foreign (state) {
    return state.foreign
  },

  // 既に登録を完了しているか
  isRegistered (state) {
    return state.result !== null
  },

  // 必要事項が入力されたか
  valid (state, getters, rootState, rootGetters) {
    const hasAgreements = rootGetters['org/hasAgreements']
    const needLicense = (rootGetters['org/needLicense'] !== C.NEED_LICENSE_NONE)

    // 許諾事項
    if (hasAgreements) {
      if (!state.agreed) {
        return false
      }
    }

    // アカウント
    if (!a.every(state.account, a.notEmpty)) {
      return false
    }

    // 個人情報
    const validProfile = a.every(state.profile, (value, name) => {
      if (name === 'gender') {
        return value > C.SEX_NOT_KNOWN
      }
      if (name === 'address2') {
        return true
      }
      return !!value
    })
    if (!validProfile) {
      return false
    }

    // 免許証
    if (needLicense) {
      const validLicense = a.every(state.license, (value, name) => {
        if (name === 'note') {
          return true
        }
        if (name === 'number') {
          return true
        }
        if (name === 'country') {
          return true
        }
        if (name === 'countryName') {
          return true
        }
        return !!value
      })
      if (!validLicense) {
        return false
      }
    }

    return true
  }
}
